import { BrandPage } from './BrandPage';

export default BrandPage;
